export default __webpack_public_path__ + "static/media/form-empty-state.7cb6daa5.svg";